// CompletedMatchesPage.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './completed-matches.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from './navbar';
import BottomBar from './BottomBar';

const CompletedMatchesPage = () => {
  const [matches, setMatches] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get('https://backend.aubattle.com/api/admin/completed-matches', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setMatches(res.data);
      } catch (err) {
        console.error("Error fetching matches:", err);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchMatches();
  }, []);

  const handleDownload = () => {
    if (selectedImage) {
      const link = document.createElement('a');
      link.href = `https://backend.aubattle.com/uploads/${selectedImage}`;
      link.download = `match-result-${Date.now()}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Loading matches...</p>
      </div>
    );
  }
  
  return (
    <div className="completed-matches-container">
      <Navbar/>
      <div className="container pt-4">
        <div className="header-section">
          <h1 className="main-title">
            <i className="bi bi-trophy-fill trophy-icon"></i> Completed Battles
          </h1>
          <button 
            className="back-btn"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-chevron-left"></i> Dashboard
          </button>
        </div>

        {matches.length === 0 ? (
          <div className="no-matches">
            <i className="bi bi-emoji-frown no-match-icon"></i>
            <p>No completed matches found</p>
          </div>
        ) : (
          <div className="matches-grid">
            {matches.map(match => (
              <div key={match.match_id} className="match-card">
                <div className="card-header">
                  <div className="match-info">
                    <h3 className="match-tag">
                      <i className="bi bi-tag-fill"></i> {match.match_tag}
                    </h3>
                    <span className="match-id">
                      <i className="bi bi-hash"></i>{match.match_id}
                    </span>
                  </div>
                  <div className="match-meta">
                    <span className="match-branch">
                      <i className="bi bi-geo-alt-fill"></i> {match.branch || 'Pakistan'}
                    </span>
                    <span className="match-time">
                      <i className="bi bi-clock-fill"></i> {new Date(match.created_at).toLocaleTimeString()}
                    </span>
                  </div>
                </div>
                <div className="card-body">
                  <div className="match-date">
                    <i className="bi bi-calendar2-event"></i>
                    {new Date(match.created_at).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric'
                    })}
                  </div>
                  
                  {match.result_screenshot && (
                    <button 
                      className="view-result-btn"
                      onClick={() => setSelectedImage(match.result_screenshot)}
                    >
                      <i className="bi bi-image"></i> View Results
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Image Modal with Download Button */}
        {selectedImage && (
          <div className="modal-backdrop" onClick={() => setSelectedImage(null)}>
            <div className="modern-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <button 
                  className="close-btn" 
                  onClick={() => setSelectedImage(null)}
                >
                  <i className="bi bi-x-lg close-icon"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="image-container">
                  <img 
                    src={`https://backend.aubattle.com/uploads/${selectedImage}`} 
                    alt="Match Result" 
                    className="modal-image"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="download-btn" onClick={handleDownload}>
                  <i className="bi bi-cloud-arrow-down-fill"></i> Download
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <BottomBar/>
    </div>
  );
};

export default CompletedMatchesPage;